import * as React from "react";
import { AmbientBackground } from "@/components/landing";
import { AuthCard, ForgotPasswordForm } from "@/components/auth";

export function ForgotPasswordPage() {
  return (
    <div className="relative min-h-screen flex items-center justify-center p-4">
      <AmbientBackground />

      <AuthCard
        title="Forgot password?"
        description="No worries, we'll send you reset instructions"
      >
        <ForgotPasswordForm />
      </AuthCard>
    </div>
  );
}

export default ForgotPasswordPage;
